module.exports = __webpack_public_path__ + "img/sub_title-0f328bf3.8d098393.jpg";